import { Fragment, type ReactElement } from "react";
import { hashSeed } from "../lib/avatar";
import { up } from "../lib/tr";

/** Ransom-note headline: each word cut from a different "magazine" (style picked deterministically). */
export function RansomTitle({ text, seed, as: Tag = "h2", className }: { text: string; seed: string; as?: "h1" | "h2" | "h3"; className?: string }): ReactElement {
  const words = up(text).split(/\s+/).filter(Boolean);
  const base = hashSeed(seed);
  return (
    <Tag className={`z-ransom ${className ?? ""}`}>
      {words.map((w, i) => (
        <Fragment key={i}>
          {i > 0 && " "}
          <span className={`z-ransom__w z-ransom__w--${(base + i * 7) % 5}`}>{w}</span>
        </Fragment>
      ))}
    </Tag>
  );
}
